<template>
  <div class="col-xs-12 p-0">
    <input
      class="search-box search-control font-16"
      type="text"
      v-model.trim="searchKeyword"
      :placeholder="placeholder"
      @keydown.enter.prevent="emitGetList"
      @keyup="fetchAccountList"
    />
    <div>
      <img
        v-if="searchKeyword"
        @click="resetSearchKeyword"
        src="/static/images/icons/danger_search_close_icon.svg"
        alt="close-icon"
        class="cursor-pointer search-reset"
      />
      <span class="vertical-line"></span>
      <span
        @click="emitGetList()"
        class="search-icon cursor-pointer"
        :class="{ 'events-none': disableSearch }"
      >
        <img src="/static/images/icons/new_search.svg" alt="search-icon" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    disableSearch: {
      required: false
    },
    fetchAccountsBasedOnSearch: {
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Search'
    }
  },

  data() {
    return {};
  },

  computed: {
    searchKeyword: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  methods: {
    resetSearchKeyword() {
      this.searchKeyword = '';
      this.emitGetList();
    },

    fetchAccountList() {
      if (this.fetchAccountsBasedOnSearch) {
        this.$emit('fetchAccount');
      }
    },

    emitGetList() {
      this.$emit('getList');
    }
  }
};
</script>

<style lang="scss" scoped>
.vertical-line {
  top: 5px;
  right: 46px;
  position: absolute;
  border-left: 1px solid $deep-gray;
  height: 75%;
}
.search-reset {
  top: 9px;
  right: 55px;
  height: 18px;
  width: 18px;
}
.search-icon {
  top: 5px;
  position: absolute;
  right: 14px;
  & img {
    width: 24px;
    height: 24px;
  }
}
.search-control {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  background: #ffffff;
  border: 0.8px solid #828282;
  border-radius: 20px;
  display: block;
  width: 100%;
  height: 36px;
  padding: 7px 90px 7px 16px;
  &:focus-visible {
    outline: none;
    box-shadow: none;
    padding-left: 15px;
    border: 2px solid #828282;
  }
  &:hover {
    box-shadow: none;
  }
}
.events-none {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
